export default __webpack_public_path__ + "static/media/krishitantra.359f602d.png";